export default "__VITE_ASSET__Bf3IH8lA__"